export default {
  setScheduleBoardFilters({ commit, state }, data) {
    commit("update", {
      state: "scheduleBoardFilters",
      data,
    });
    // Cache filters — except the date: the board date is URL-driven
    // (?start=), so it must never be resurrected from a previous session
    let filterCache = { ...state.scheduleBoardFilters, ...data };
    delete filterCache.start;
    localStorage.setItem("scheduleBoardFilters", JSON.stringify(filterCache));
  },
  assignDraggedAppointment(_, data) {
    const { appointmentId, ...apiParams } = data;

    // FIXME: should use API.makeRequest instead of ajax
    // this api endpoing authentication needs to be updated in the backend
    return new Promise((resolve, reject) => {
      $.ajax(`/appointments_calendar/${appointmentId}/set_tech`, {
        method: "PUT",
        data: apiParams,
        success: resolve,
        error: reject,
      });
    });
  },
};
